var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 1.4375V2.375H1.5C0.671875 2.375 0 3.00488 0 3.78125V5.1875H14V3.78125C14 3.00488 13.3281 2.375 12.5 2.375H11V1.4375C11 0.918945 10.5531 0.5 10 0.5C9.44687 0.5 9 0.918945 9 1.4375V2.375H5V1.4375C5 0.918945 4.55313 0.5 4 0.5C3.44687 0.5 3 0.918945 3 1.4375ZM14 6.125H0V14.0938C0 14.8701 0.671875 15.5 1.5 15.5H12.5C13.3281 15.5 14 14.8701 14 14.0938V6.125Z",
    fill: "#364261"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDate);
export default __webpack_public_path__ + "static/media/document_date.7dc8d3728f9a827f294c965030c0322e.svg";
export { ForwardRef as ReactComponent };